export default "__VITE_ASSET__Dh06zU4P__"